import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

import Button from '../../../components/ui/Button';

const PromotionalOffers = ({ offers }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Special Offers</h2>
        <Link to="/offers">
          <Button variant="outline" size="sm" iconName="ArrowRight" iconPosition="right">
            View All
          </Button>
        </Link>
      </div>
      
      {offers.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="Gift" size={48} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground">No special offers available</p>
        </div>
      ) : (
        <div className="space-y-4">
          {offers.map((offer) => (
            <div key={offer.id} className="relative bg-gradient-to-r from-accent/10 to-accent/5 border border-accent/20 rounded-lg p-4 overflow-hidden">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="w-16 h-16 bg-accent/20 rounded-lg flex items-center justify-center">
                    <Icon name={offer.icon} size={24} className="text-accent" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground mb-1">{offer.title}</h3>
                    <p className="text-sm text-muted-foreground mb-2">{offer.description}</p>
                    <div className="flex items-center space-x-4 text-xs text-muted-foreground">
                      <span className="flex items-center space-x-1">
                        <Icon name="Clock" size={12} />
                        <span>Expires: {offer.expiryDate}</span>
                      </span>
                      <span className="flex items-center space-x-1">
                        <Icon name="Tag" size={12} />
                        <span>Code: {offer.code}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-2xl font-bold text-accent mb-2">{offer.discount}</p>
                  <Button variant="default" size="sm">
                    Use Now
                  </Button>
                </div>
              </div>
              {offer.badge && (
                <div className="absolute top-2 right-2 bg-accent text-accent-foreground text-xs font-medium px-2 py-1 rounded">
                  {offer.badge}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PromotionalOffers;